<template>
  <div>
    <h2>Пользователи</h2>

    <!-- add button -->
    <b-row class="mt-5 mb-2">
      <b-col>
        <b-button class="mb-1" v-b-modal.modal-new v-on:click="onCreateButton">Добавить</b-button>

        <b-modal id="modal-new" size="lg" :title="'Новый пользователь'" hide-footer>
          <b-form @submit.prevent="addUser" size="sm">
            <p>Выбранному пользователю будет назначена роль для доступа в CRM. Пользователя можно будет указывать в качестве ответственного лица в задачах</p>
            <b-form-group label="Выберите пользователя:" label-cols-sm="4" label-cols-lg="4">
              <multi-select
                v-model="new_user.user"
                :options="optionsResponsible"
                :searchable="true"
                :loading="isLoadingResponsible"
                :internal-search="false"
                :hide-selected="true"
                track-by="last_name"
                label="last_name"
                placeholder="Введите имя для поиска"
                selectLabel="Enter чтобы выбрать"
                @search-change="asyncFindResponsible"
              >
                <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
                <template slot="noOptions">Начните вводить имя</template>
                <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
                <span slot="noResult">Не найдено</span>
              </multi-select>
            </b-form-group>
            <b-form-group label="Номер Sipuni:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="new_user.sipuni_number"></b-input>
            </b-form-group>
            <b-alert v-model="error" dismissible variant="danger">{{ message }}</b-alert>
            <loading-button :is-busy="isBusyButton" :text="'Добавить'"></loading-button>
          </b-form>
        </b-modal>

        <b-modal id="modal-1" size="lg" :title="isUpdate ? 'Редактирование пользователя':'Новый пользователь'" hide-footer>
          <b-form @submit="updateUser" size="sm">
            <b-form-group label="Фамилия:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="form.last_name" readonly></b-input>
            </b-form-group>
            <b-form-group label="Имя:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="form.first_name" readonly></b-input>
            </b-form-group>
            <b-form-group label="Отчество:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="form.middle_name" readonly></b-input>
            </b-form-group>
            <b-form-group label="Телефон:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="form.phone" readonly></b-input>
            </b-form-group>
            <b-form-group label="Email:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="form.email" readonly></b-input>
            </b-form-group>
            <b-form-group label="Номер Sipuni:" label-cols-sm="4" label-cols-lg="4">
              <b-input v-model="form.sipuni_number"></b-input>
            </b-form-group>
            <b-alert v-model="error" dismissible variant="danger">{{ message }}</b-alert>
            <loading-button :is-busy="isBusyButton" :text="isUpdate ? 'Сохранить':'Создать'"></loading-button>
          </b-form>
        </b-modal>
      </b-col>
    </b-row>

    <!-- table -->
    <div>
      <b-table striped hover small show-empty ref="table"
               :items="tableDataProvider"
               :fields="fields"
               :busy.sync="isBusy"
               empty-text="Нет пользователей"
               empty-filtered-text="Не найдено"
               :per-page="perPage"
               :current-page="currentPage">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Загрузка...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button-group>
            <b-button v-on:click="show(data.item)" variant="primary" size="sm">
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button v-on:click="remove(data.item.id)" variant="danger" size="sm">
              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-pagination align="center"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="my-table"
      ></b-pagination>
    </div>

  </div>
</template>
<script>
import LoadingButton from "../components/LoadingButton";
import commonMixin from '../mixins/common';
import MultiSelect from "vue-multiselect";

export default {
  name: "Users",
  mixins: [commonMixin],
  components: {LoadingButton, MultiSelect},
  data() {
    return {
      isLoadingResponsible: false,
      optionsResponsible: [],
      new_user: {user: null, sipuni_number: ''},
      isUpdate: false,
      isBusy: false,
      isBusyButton: false,
      isLoading: false,
      totalRows: 1,
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      searchQuery: {
        query: '',
      },
      fields: [
        {key: 'last_name', label: 'Фамилия'},
        {key: 'first_name', label: 'Имя'},
        {key: 'middle_name', label: 'Отчество'},
        {key: 'phone', label: 'Телефон'},
        {key: 'email', label: 'Email'},
        {key: 'sipuni_number', label: 'Номер Sipuni'},
        {key: 'actions', label: 'Действия'}
      ],
      items: [],

      form: {
        last_name: '',
        first_name: '',
        middle_name: '',
        phone: '',
        email: '',
        sipuni_number: '',
      }
    }
  }, mounted() {
    let id = this.$route.hash.replace(/^#+/g, '');
    if (id) {
      this.show(id);
    }
  },
  methods: {
    asyncFindResponsible(query) {
      this.isLoadingResponsible = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?all-users=1&query=' + query);
      return promise.then(response => {
        this.optionsResponsible = response.data.users;
        this.isLoadingResponsible = false;
      }).catch((error) => {
        console.log(error);
        this.optionsResponsible = [];
        this.isLoadingResponsible = false;
      });
    },
    onCreateButton() {
      this.new_user.user = null;
      this.new_user.sipuni_number = '';
      this.isUpdate = false;
    },
    addUser() {
      this.error = false;
      this.isBusyButton = true;
      this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/users/', JSON.stringify(this.new_user))
        .then((response) => {
          this.isBusyButton = false;
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.$bvModal.hide('modal-new');
              this.$refs.table.refresh();
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.message = "Ошибка сервера";
        })
    },
    updateUser(evt) {
      evt.preventDefault();
      this.error = false;
      this.isBusyButton = true;
      let promise = null;
      if (this.isUpdate) {
        promise = this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/users/' + this.form.id, JSON.stringify(this.form));
      } else {
        promise = this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/users/', JSON.stringify(this.form));
      }

      return promise.then((response) => {
        this.isBusyButton = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.$bvModal.hide('modal-1');
            this.$refs.table.refresh();
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      })
    },
    submitSearch(evt) {
      evt.preventDefault();
      this.$refs.table.refresh();
    },
    tableDataProvider(ctx) {
      return this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?page=' +
        ctx.currentPage + '&perpage=' + ctx.perPage + "&query=" + this.searchQuery.query)
        .then(response => {
          this.items = response.data.users;
          this.totalRows = response.data.totalRows;
          return this.items || []
        })
        .catch((error) => {
          console.log(error);
          this.items = [];
          this.totalRows = 0;
          return this.items || []
        });
    },
    remove(id) {
        if (confirm("Удалить пользователя #" + id + "?")) {
            this.error = false;
            this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/users/' + id, {})
              .then((response) => {
                if (response) {
                    if (response.data.error === false) {
                        this.error = false;
                        this.$refs.table.refresh()
                    } else {
                        console.log(response.data.message);
                    }
                }
            })
        }
    },
    show(item) {
      this.isUpdate = true;
      this.error = false;
      this.form = item;
      this.$bvModal.show('modal-1');
    },
  },
}
</script>

<style lang="scss">
.hidden-overflow {
  overflow: hidden;
  white-space: pre-wrap;
}
</style>
